import { Badge } from '@/shared/ui/badge';
import { MessageSquare } from 'lucide-react';

interface ResponseReceivedBadgeProps {
  /** True when a more-info reply / approved duration challenge has been received. */
  hasResponse: boolean;
}

/**
 * "Response Received" badge for a job row. Mirrors the badge shown on the job
 * detail page (StatusBar) — same green styling and icon — and renders only when
 * the job has a received response.
 */
export function ResponseReceivedBadge({ hasResponse }: ResponseReceivedBadgeProps) {
  if (!hasResponse) return null;

  return (
    <Badge className="bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/30 hover:bg-green-500/20 gap-1 text-nowrap">
      <MessageSquare className="size-3 shrink-0" />
      Response Received
    </Badge>
  );
}
